function veda_fn_70cebfb061e54f939e007676c6f77490 () {
        
  if (window.veda_fn_70cebfb061e54f939e007676c6f77490Cleanup === undefined) {
    window.veda_fn_70cebfb061e54f939e007676c6f77490Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_70cebfb061e54f939e007676c6f77490Cleanup.cleanup();

        const uniqueIds = ["id_2fe209db-8c82-4e09-bf92-24f2f51d4a49","id_f3934719-b4b6-4074-a9fa-d956aba02b29","id_955e6107-b78a-4e35-9c62-f495fd9e0617","id_b7adc06b-52e2-4cb1-a91b-e202306133f2","id_55eb43f3-eed3-4ebc-8806-101e6cd0d299","id_b7004f75-b6f2-40ad-a25a-41536e10e0e5","id_bfc16fd4-6410-4e10-9118-047ee628e9a1","id_aa0f0c7e-4670-42de-9359-e20c68ce163a","id_4163e23e-96ac-4073-9b77-5aa3640fa153","id_5a346897-6459-4f95-8a1c-54973e930f7f","id_9c15f65e-36ed-4827-9cb3-5be0e1c5d506","id_d4dc4d94-6f99-42cc-9d09-b205cfb0b5b5"];
        uniqueIds.forEach(uniqueId => {
          const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
          containers.forEach(container => {
            if (!container) {
              return;
            }
            veda.plugins.videoCover(container);
            
          });
        });
      }
veda_fn_70cebfb061e54f939e007676c6f77490();
function veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91 () {
      
  if (window.veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91Cleanup === undefined) {
    window.veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91Cleanup.cleanup();

      const uniqueId = "id_7adb6c16-f937-47d4-b9ee-873d3f8cc670";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        const { sticky, mobileMenu } = veda.plugins;
const socialEl = container.querySelector(".social-js");
const stickyEl = container.querySelector(".veda-sticky");

function getSectionBackground(defaultValue) {
  const vedaBackgroundEl = container.querySelector(".veda-background");
  if (vedaBackgroundEl && vedaBackgroundEl.style.backgroundColor) {
    return vedaBackgroundEl.style.backgroundColor;
  }
  return defaultValue;
}

function containerZIndex() {
  function handleContainerClick() {
    container.style.zIndex = "999";
  }

  function handleWindowClick(event) {
    if (!container.contains(event.target)) {
      container.style.removeProperty("z-index");
    }
  }
  container.addEventListener("click", handleContainerClick);
  window.addEventListener("click", handleWindowClick);

  window.veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91Cleanup.push(() => {
    container.removeEventListener("click", handleContainerClick);
    window.removeEventListener("click", handleWindowClick);
  });
}
containerZIndex();

function navigation() {
  const appendElements = [];
  const menu = mobileMenu(container, {
    backClassName: "p:15px c:color-gray9 bdb:1px_solid_color-gray2",
    closeClassName: "w:100% p:8px_15px c:color-gray9 bdb:1px_solid_color-gray2",
    appendElements,
  });

  function checkResponsive() {
    if (window.innerWidth > 992) {
      menu.destroy();
    } else {
      menu.init();
    }
  }
  checkResponsive();
  window.addEventListener("resize", checkResponsive);
}
navigation();

let isSticky = false;
function headerSticky() {
  if (stickyEl) {
    const destroy = sticky(stickyEl, {
      onChange(sticky) {
        if (sticky !== isSticky) {
          if (sticky) {
            stickyEl.style.backgroundColor =
              getSectionBackground("var(--color-light)");
          } else {
            stickyEl.style.removeProperty("background-color");
          }
          isSticky = sticky;
        }
      },
    });
    window.veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91Cleanup.push(() => {
      destroy();
    });
  }
}

headerSticky();
      });
    }
veda_fn_83d4d9e55e724e00aa03cd7b34f6fd91();
function veda_fn_2c1efe3deed946f8be280d5a8e364844 () {
      
  if (window.veda_fn_2c1efe3deed946f8be280d5a8e364844Cleanup === undefined) {
    window.veda_fn_2c1efe3deed946f8be280d5a8e364844Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_2c1efe3deed946f8be280d5a8e364844Cleanup.cleanup();

      const uniqueId = "id_82f659f4-192a-430b-98dc-2ae3b41a4030";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        const { createIntersectionObserver } = veda.utils;

const intersectionObserver = createIntersectionObserver({
  rootMargin: "0px",
});
const videoEl = container.querySelector(".veda-video-js");
function handleVideo(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      videoEl.play();
    } else {
      videoEl.pause();
    }
  });
}
intersectionObserver.addListener(handleVideo, videoEl);
window.veda_fn_2c1efe3deed946f8be280d5a8e364844Cleanup.push(() => {
  intersectionObserver.removeListener(handleVideo);
});
      });
    }
veda_fn_2c1efe3deed946f8be280d5a8e364844();
function veda_fn_b2d8bc9a3e1e4aaaa8f6183d75cfbdee () {
      
  if (window.veda_fn_b2d8bc9a3e1e4aaaa8f6183d75cfbdeeCleanup === undefined) {
    window.veda_fn_b2d8bc9a3e1e4aaaa8f6183d75cfbdeeCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_b2d8bc9a3e1e4aaaa8f6183d75cfbdeeCleanup.cleanup();

      const uniqueId = "id_79e2882f-8764-4d0c-88af-7f11df2dae61";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        const { message } = veda.plugins;
const { objectParse, imageUrl, getObjectAttributes } = veda.utils;
let loading = false;

function handleTabs() {
  const tabEl = container.querySelector(".veda-tabs");
  const cssLink = getObjectAttributes(tabEl.getAttribute("tabs-data-css"));
  const cssActiveLink = getObjectAttributes(
    tabEl.getAttribute("tabs-data-css-active")
  );
  const tabLinkEls = tabEl.querySelectorAll(".veda-tabs__link");
  const buttonViewAllTopEl = container.querySelector(
    ".product-tab-button-view-all"
  );
  const viewAllLinkEl = container.querySelector(".tab-vendor-link");
  const viewAllLinkData = objectParse(viewAllLinkEl.textContent);
  console.log(viewAllLinkData);
  const instance = veda.plugins.tabs(tabEl, {
    activeIndex: 0,
    addClassName: "",
    removeClassName: "",
    onChange: (activeIndex) => {
      const activeButtonViewAll = container.querySelector(
        `.button-view-all-top[data-index="${activeIndex}"]`
      );
      tabLinkEls.forEach((tabLinkEl, index) => {
        if (index != activeIndex) {
          tabLinkEl.setAttribute("data-css", cssLink["data-css"]);
        }
      });
      if (!!buttonViewAllTopEl) {
        buttonViewAllTopEl.href = viewAllLinkData[activeIndex];
      }
      tabLinkEls[activeIndex].setAttribute(
        "data-css",
        cssActiveLink["data-css"]
      );
      if (!!activeButtonViewAll) {
        activeButtonViewAll.classList.remove("d:none");
        activeButtonViewAll.classList.add("d:inline-flex");
      }
    },
  });
  window.veda_fn_b2d8bc9a3e1e4aaaa8f6183d75cfbdeeCleanup.push(() => {
    instance.destroy();
  });
}

handleTabs();
      });
    }
veda_fn_b2d8bc9a3e1e4aaaa8f6183d75cfbdee();
function veda_fn_07ef4feba8b34c93a634925875fd6d49 () {
      
  if (window.veda_fn_07ef4feba8b34c93a634925875fd6d49Cleanup === undefined) {
    window.veda_fn_07ef4feba8b34c93a634925875fd6d49Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_07ef4feba8b34c93a634925875fd6d49Cleanup.cleanup();

      const uniqueId = "id_5e3da692-6751-455d-b9b8-b12fcba09fa6";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        const rowEls = container.querySelectorAll(".table-row-item-js");
const viewAllContainer = container.querySelector(".view-all-container");
const buttonViewAll = container.querySelector(".view-all-button-js");
if (rowEls.length <= 11) {
  viewAllContainer.classList.add("d:none!");
}
rowEls.forEach((rowEl, index) => {
  if (index > 10) {
    rowEl.classList.add("d:none");
  }
});

const handleClick = () => {
  rowEls.forEach((rowEl) => {
    rowEl.classList.remove("d:none");
  });
  viewAllContainer.classList.add("d:none!");
};
if (!!buttonViewAll) {
  buttonViewAll.addEventListener("click", handleClick);
  window.veda_fn_07ef4feba8b34c93a634925875fd6d49Cleanup.push(() => {
    buttonViewAll.removeEventListener("click", handleClick);
  });
}
      });
    }
veda_fn_07ef4feba8b34c93a634925875fd6d49();
function veda_fn_e6b16fe070f74f349a5626b159f329fd () {
      
  if (window.veda_fn_e6b16fe070f74f349a5626b159f329fdCleanup === undefined) {
    window.veda_fn_e6b16fe070f74f349a5626b159f329fdCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_e6b16fe070f74f349a5626b159f329fdCleanup.cleanup();

      const uniqueId = "id_4392882f-7263-4c7c-8dac-1afb2f3aec0f";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        const videoButtonEls = container.querySelectorAll(".veda-video-button-js");
const videosEl = document.querySelector(`.veda-videos-${uniqueId}-js`);
const videoEls = videosEl.querySelectorAll(".veda-video-js");
const videoCloseEls = videosEl.querySelectorAll(
  ".veda-video-close-js, .veda-video-overlay-js"
);

videoButtonEls.forEach((videoButtonEl) => {
  function handleClick() {
    const id = videoButtonEl.getAttribute("data-button-video-id");
    const videoEl = videosEl.querySelector(`[data-video-id="${id}"`);
    if (videoEl) {
      const videoContentEl = videoEl.querySelector(".veda-video-content-js");
      const embedEl = videoEl.querySelector(".veda-embed-js");
      const src = embedEl.getAttribute("data-src");
      embedEl.innerHTML = `<iframe src="${src}" frameborder="0"></iframe>`;
      videoEl.style.visibility = "visible";
      videoContentEl.style.opacity = 1;
      videoContentEl.style.transform = "scale(1)";
    }
  }
  videoButtonEl.addEventListener("click", handleClick);
  window.veda_fn_e6b16fe070f74f349a5626b159f329fdCleanup.push(() => {
    videoButtonEl.removeEventListener("click", handleClick);
  });
});

videoCloseEls.forEach((videoCloseEl) => {
  function handleClose() {
    const videoEl = videoCloseEl.closest(".veda-video-js");
    const videoContentEl = videoEl.querySelector(".veda-video-content-js");
    const embedEl = videoEl.querySelector(".veda-embed-js");
    videoEl.style.removeProperty("visibility");
    videoContentEl.style.removeProperty("opacity");
    videoContentEl.style.removeProperty("transform");
    embedEl.innerHTML = "";
  }

  videoCloseEl.addEventListener("click", handleClose);

  window.veda_fn_e6b16fe070f74f349a5626b159f329fdCleanup.push(() => {
    videoCloseEl.removeEventListener("click", handleClose);
  });
});
      });
    }
veda_fn_e6b16fe070f74f349a5626b159f329fd();
function veda_fn_f679a938eef440f99e5e217ef7d3728f () {
        
  if (window.veda_fn_f679a938eef440f99e5e217ef7d3728fCleanup === undefined) {
    window.veda_fn_f679a938eef440f99e5e217ef7d3728fCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_f679a938eef440f99e5e217ef7d3728fCleanup.cleanup();

        const uniqueIds = ["id_c2688e0f-bfe0-41a7-a2c8-7e05961eb772","id_cfecc4f2-970e-4ae4-bfb8-b6c103ea2f2f"];
        uniqueIds.forEach(uniqueId => {
          const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
          containers.forEach(container => {
            if (!container) {
              return;
            }
            veda.plugins.videoCover(container);
            const instance = veda.plugins.swiper(container);
window.veda_fn_f679a938eef440f99e5e217ef7d3728fCleanup.push(() => {
  instance.destroy();
});
          });
        });
      }
veda_fn_f679a938eef440f99e5e217ef7d3728f();
function veda_fn_cf929c3dddd64f7588b19c0456329f06 () {
      
  if (window.veda_fn_cf929c3dddd64f7588b19c0456329f06Cleanup === undefined) {
    window.veda_fn_cf929c3dddd64f7588b19c0456329f06Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_cf929c3dddd64f7588b19c0456329f06Cleanup.cleanup();

      const uniqueId = "id_898fe880-a081-4646-b03c-09ab29d434d9";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        const { parallaxScroll } = veda.plugins;
const { offset, random } = veda.utils;

const prSectionEl = document.querySelector(".pr-section");
const prItemEls = document.querySelectorAll(".pr-item");
const prSection = parallaxScroll(prSectionEl);

prItemEls.forEach((prItemEl, index) => {
  const left = random(5, 40);
  const right = random(60, 95);
  const randomLeft = index < prItemEls.length / 2 ? left : right;
  const scale = random(10, 25) / 10;

  prItemEl.style.top = `${random(5, 95)}%`;
  prItemEl.style.left = `${randomLeft}%`;
  prItemEl.style.zIndex = scale * 10;
  prItemEl.children[0].style.transform = `scale(${scale})`;

  prSection.add(prItemEl, {
    from() {
      return offset(prSectionEl).top - window.innerHeight;
    },
    to() {
      return offset(prSectionEl).top + prSectionEl.offsetHeight;
    },
    keyframes: {
      "0%": {
        y: 100 * scale,
      },
      "100%": {
        y: -100 * scale,
      },
    },
  });
});
const item2 = document.querySelector(".pr-text");
prSection.add(item2, {
  from() {
    return offset(prSectionEl).top - window.innerHeight;
  },
  to() {
    return offset(prSectionEl).top + prSectionEl.offsetHeight;
  },
  keyframes: {
    "0%": {
      y: 50,
    },
    "100%": {
      y: -50,
    },
  },
});

prSection.run();

const destroy = veda.plugins.backgroundParallax(prSectionEl, { speed: 0.8 });

function handleResize() {
  prSection.run();
}
window.addEventListener("resize", handleResize);
window.veda_fn_cf929c3dddd64f7588b19c0456329f06Cleanup.push(() => {
  prSection.destroy();
  destroy();
  window.removeEventListener("resize", handleResize);
});
      });
    }
veda_fn_cf929c3dddd64f7588b19c0456329f06();
function veda_fn_b373427fab174cfa908ebb8823750294 () {
      
  if (window.veda_fn_b373427fab174cfa908ebb8823750294Cleanup === undefined) {
    window.veda_fn_b373427fab174cfa908ebb8823750294Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_b373427fab174cfa908ebb8823750294Cleanup.cleanup();

      const uniqueId = "id_0deb40c4-39e0-4239-aeb5-e5491be66107";
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        class CoreMasonryEvent {
  constructor() {
    this.events = {};
    this.mounted = false;
  }
  emit(eventType) {
    if (this.events[eventType]) {
      this.events[eventType].forEach((listener) => {
        listener();
      });
    }
  }
  on(eventType, listener) {
    this.events = Object.assign(Object.assign({}, this.events), {
      [eventType]: [...(this.events[eventType] || []), listener],
    });
    if (this.eventMount && !this.mounted) {
      this.eventMount();
      this.mounted = true;
    }
  }
}
class CoreMasonry extends CoreMasonryEvent {
  constructor(selector, options) {
    super();
    this.selector = selector;
    this.options = options;
    const defaultOptions = {
      defaultColumn: 3,
      gap: 10,
      columnClassName: "veda-masonry__item",
      responsive: [],
    };
    this.els = Array.from(document.querySelectorAll(selector));
    this.opts = Object.assign(Object.assign({}, defaultOptions), options);
    this.resized = false;
    this.heights = Array(this.getColumn()).fill(0);
    this.debounceId = 0;
    this.init();
  }
  getColumn() {
    const { responsive, defaultColumn } = this.opts;
    const windowWidth = window.innerWidth;
    if (!responsive.length) {
      return defaultColumn;
    }
    let nextIndex = 0;
    let columnResponsive = defaultColumn;
    responsive.forEach(({ breakpoint, column }, index) => {
      nextIndex = Math.min(index + 1, responsive.length);
      const nextBreakpoint = responsive[nextIndex]
        ? responsive[nextIndex].breakpoint
        : Infinity;
      if (breakpoint <= windowWidth && nextBreakpoint - 1 >= windowWidth) {
        columnResponsive = column;
      }
    });
    return columnResponsive;
  }
  getMinHeight() {
    return Math.min(...this.heights);
  }
  getMaxHeight() {
    return Math.max(...this.heights);
  }
  getIndexSelected() {
    return this.heights.findIndex((item) => item === this.getMinHeight());
  }
  setItemStyles(columnElement) {
    const { gap } = this.opts;
    const column = this.getColumn();
    const indexSelected = this.getIndexSelected();
    columnElement.style.position = "absolute";
    columnElement.style.width = `${100 / column}%`;
    columnElement.style.left = `${(100 / column) * indexSelected}%`;
    columnElement.style.top = `${this.getMinHeight()}px`;
    columnElement.style.padding = `${gap / 2}px`;
    if (this.resized) {
      columnElement.style.transition = "all 0.4s ease";
    }
  }
  handleColumnElement(columnElement) {
    const indexSelected = this.getIndexSelected();
    this.setItemStyles(columnElement);
    this.heights[indexSelected] += columnElement.offsetHeight;
  }
  handleMasonryElement(el) {
    const { columnClassName, gap } = this.opts;
    const itemElements = Array.from(el.querySelectorAll(`.${columnClassName}`));
    itemElements.forEach(this.handleColumnElement.bind(this));
    el.style.position = "relative";
    el.style.height = `${this.getMaxHeight()}px`;
    el.style.margin = `-${gap / 2}`;
    // debounce remove transition
    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }
    this.debounceId = window.setTimeout(() => {
      itemElements.forEach((columnElement) => {
        columnElement.style.removeProperty("transition");
      });
    }, 500);
  }
  handleWindowResize() {
    this.resized = true;
    this.update();
    this.emit("resize");
  }

  // eventMount() {
  //   this.init();
  // }
  init() {
    this.update();
    window.addEventListener("resize", this.handleWindowResize.bind(this));
    this.emit("load");
  }
  update() {
    this.heights = Array(this.getColumn()).fill(0);
    this.els.forEach(this.handleMasonryElement.bind(this));
    this.emit("update");
  }
}
function masonry(selector, options) {
  return new CoreMasonry(selector, options);
}

const currentMasonry = masonry(".veda-masonry", {
  defaultColumn: 3,
  gap: 30,
  columnClassName: "masonry__item",
  responsive: [
    { breakpoint: 480, column: 2 },
    { breakpoint: 768, column: 3 },
    { breakpoint: 992, column: 3 },
  ],
});
currentMasonry.on("load", () => {
  console.log("load");
});
currentMasonry.on("resize", () => {
  console.log("resize");
});
      });
    }
veda_fn_b373427fab174cfa908ebb8823750294();